import React from 'react';
import { graphql } from "gatsby"

import Pancake from "./Pancake";
import Container from "../Container";
import PancakeIntro from "../PancakeIntro";
import Person from "../Person"

import "./Team.scss";

const TeamPancake = props => {

  const { title, text, speakers, theme } = props;

  return (
    <Pancake className="TeamPancake" theme={theme}>
      <Container>
        <PancakeIntro title={title} text={text} />
        <div className="TeamPancakeGrid">
          {speakers?.map(speaker => <div className="PersonCard"><Person person={speaker}  key={speaker.name} /></div>)}
        </div>
      </Container>
    </Pancake>
  );
}

export const query = graphql`
  fragment SanitySpeakersPancake on SanitySpeakers {
    _key
    _type
    pancakeIntro {
      pancakeTitle
      pancakeText
    }
    speakers {
      name
      jobtitle
      company {
        name
      }
      _id
      image {
        ...ImageWithPreview
      }
    }
    theme
  }
`

export default TeamPancake;